import { useCallback, useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaTrash, FaExchangeAlt } from 'react-icons/fa';

import { getInventoryStores } from '../../helpers/Stores';

const LocationItem = ({ 
    location, 
    item, 
    locationFilters,
    handleMoveLocationItem,
    handleRemoveLocationItem,
    }) => {

    const [newLocationStore, setNewLocationStore] = useState(locationFilters.store);
    const [newLocationName, setNewLocationName] = useState(null);

    const handleRemove = useCallback(
        (location, item) => {
            handleRemoveLocationItem(location, item);
        }, [handleRemoveLocationItem]
    );

    const handleMove = useCallback(
        (event) => {
            event.preventDefault();
            handleMoveLocationItem(location, item, newLocationStore, newLocationName.trim());
        }, [location, item, handleMoveLocationItem, newLocationStore, newLocationName]
    );

    const moving = false;
    const removing = false;

    let highligh = false;
    if (locationFilters.skuSearch && item.sku) {
        highligh = item.sku.startsWith(locationFilters.skuSearch);
    }

    const taken = !!item.takenAt;

    const movePopover =  (
        <Popover id="popover-label" className="inventoryMovePopover">
            <Popover.Header as="h3">
                Cambiar a otra ubicación
            </Popover.Header>
            <Popover.Body className="me-2">
                {moving
                ? <div className="text-center"> 
                    <Spinner animation="border" role="status" size="sm"/>
                </div>
                : <Form onSubmit={handleMove}>
                    <Row>
                        <Col sm={3}>
                            <Form.Select
                                name="newLocationStore"
                                onChange={(event) => setNewLocationStore(event.currentTarget.value)}
                                defaultValue={locationFilters.store}
                            >
                                {getInventoryStores().map((option, index) => (
                                    <option
                                        key={"option_" + index}
                                        value={option}
                                    >
                                        {option}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Form.Group as={Col} sm={6}>
                            <Form.Control
                                required
                                name="newLocationName"
                                type="text"
                                placeholder="Ingresa la ubicación"
                                onChange={(event) => setNewLocationName(event.currentTarget.value)}
                            />
                        </Form.Group>
                        <Col sm={3}>
                            <Button 
                                className="w-100" 
                                type="submit" 
                                variant="primary"
                                disabled={!newLocationStore || !newLocationName}
                            >
                                Cambiar
                            </Button>
                        </Col>
                    </Row>
                </Form>
                }
            </Popover.Body>
        </Popover>
    );

    return (
        <Badge 
            className="m-1 inventorySkuItem d-flex justify-content-between border" 
            bg="light"
        >
            <div 
                className={"my-auto " + (highligh ? "text-primary" : "text-dark") + (taken ? " text-decoration-line-through" : "")}
            >
                {item.sku}
            </div>
            <div>
                <OverlayTrigger rootClose trigger="click" placement="left" overlay={movePopover}>
                    <Button 
                        variant="light"
                        size="sm"
                        className="border"
                    >
                        {moving
                        ? <Spinner size="sm" style={{ marginLeft: "-0.1em", marginRight: "-0.1em" }} />
                        : <FaExchangeAlt className="mb-1"/>
                        }
                    </Button>
                </OverlayTrigger>

                <Button 
                    variant="danger"
                    size="sm"
                    className="border"
                    onClick={() => handleRemove(location, item)}
                >
                    {removing
                    ? <Spinner size="sm" style={{ marginLeft: "-0.1em", marginRight: "-0.1em" }} />
                    : <FaTrash className="mb-1"/>
                    }
                </Button>
            </div>
        </Badge>
    );
};

export default LocationItem;
